import { gql } from '$lib/apollo';

export const FOOTER_GAMES = gql`
  query FooterGames {
    games(first: 5, sort: [{ on: HOME_PAGE, direction: DESCENDING }]) {
      edges {
        node {
          id
          slug
          localizedTitles {
            en
          }
        }
      }
    }
  }
`;

export const GET_GAME_MINIMAL = gql`
  query GetGameMinimal($slug: String) {
    game(slug: $slug) {
      id
      slug
      localizedTitles {
        en
      }
    }
  }
`;
